import Vue from 'vue'

import {
  addCustomWidgetSchema
} from '@/components/form-designer/widget-panel/widgetsConfig'
import * as PERegister from '@/components/form-designer/setting-panel/propertyRegister'
import * as PEFactory from '@/components/form-designer/setting-panel/property-editor-factory'

import { alertSchema } from "@/extension/samples/extension-schema"
import AlertWidget from '@/extension/samples/alert/alert-widget'
import { registerFWGenerator } from '@/utils/sfc-generator'
import { alertTemplateGenerator } from '@/extension/samples/extension-sfc-generator'

// 卡片
import "@/extension/card/init"
// 多文本
import "@/extension/combo-gird/init"
// 多文本
import "@/extension/combo-gird-km/init"

// 机构
import "@/extension/office-tree/init"

// 时间
import "@/extension/date-time/init"

// // 时间2
// import "@/extension/date-time2/init"

// 2文本框
import "@/extension/two-input/init"

// 树
import "@/extension/tree/init"

// 地址组件
import "@/extension/address-editor/init"

// 打印
import "@/extension/print-button/init"
// 打印
import "@/extension/printTemp-button/init"

// h5地址
// import "@/extension/h5/area/init"

// h5选择器
import "@/extension/h5/picker/init"

// h5日期选择器
import "@/extension/h5/datetime-picker/init"

// h5弹窗选择器
import "@/extension/h5/dialog/init"

// h5弹窗选择器
import "@/extension/h5/address/init"

//日历
import "@/extension/h5/calendar/init"

//文本
import "@/extension/h5/field/init"
//文本
import "@/extension/h5/two-field/init"
// //数字输入框
// import "@/extension/inputNumber/init"

export const loadExtension = function () {

  /**
   * 加载字段组件步骤：
   * 1. 加载组件Json Schema;
   * 2. 全局注册字段组件，字段组件设计期和运行期共用，故需要仅需注册一个组件；
   * 3. 全局注册属性编辑器组件（基本属性、高级属性、事件属性）；
   * 4. 注册字段组件的代码生成器；
   * 5. 加载完毕。
   */
  addCustomWidgetSchema(alertSchema)  //加载组件Json Schema
  /* -------------------------------------------------- */
  Vue.component(AlertWidget.name, AlertWidget)  //注册组件
  /* -------------------------------------------------- */
  PERegister.registerCPEditor('alert-title', 'alert-title-editor',
    PEFactory.createInputTextEditor('title', 'extension.setting.alertTitle'))

  // PERegister.registerCPEditor('font-size', 'font-size-editor',
  //   PEFactory.createInputTextEditor('size', '文字大小'))

  PERegister.registerCPEditor('ntDefaultValue', 'ntDefaultValue-editor',
    PEFactory.createInputTextEditor('ntDefaultValue', '默认值'))

  let typeOptions = [
    { label: 'success', value: 'success' },
    { label: 'warning', value: 'warning' },
    { label: 'info', value: 'info' },
    { label: 'error', value: 'error' },
  ]
  // PERegister.registerCPEditor('alert-type', 'alert-type-editor',
  //     PEFactory.createSelectEditor('type', 'extension.setting.alertType',
  //         {optionItems: typeOptions}))
  /* type属性映射已存在，无须再注册，故只需注册属性编辑器即可！！ */
  Vue.component('alert-type-editor',
    PEFactory.createSelectEditor('type', 'extension.setting.alertType',
      { optionItems: typeOptions }))

  PERegister.registerCPEditor('alert-description', 'alert-description-editor',
    PEFactory.createInputTextEditor('description', 'extension.setting.description'))

  PERegister.registerCPEditor('alert-closable', 'alert-closable-editor',
    PEFactory.createBooleanEditor('closable', 'extension.setting.closable'))
    // 固定文本框高度
    let fixedHeightOptions = [
      { label: '5个', value: '1' },
      { label: '10个', value: '2' },
      { label: '15个', value: '3' },
      { label: '不限制', value: '4' },
    ]
    // PERegister.registerCPEditor('alert-type', 'alert-type-editor',
    //     PEFactory.createSelectEditor('type', 'extension.setting.alertType',
    //         {optionItems: typeOptions}))
    /* type属性映射已存在，无须再注册，故只需注册属性编辑器即可！！ */
    Vue.component('fixed-height-editor',
      PEFactory.createSelectEditor('fixedHeight', '下拉框显示数量',
        { optionItems: fixedHeightOptions }))

  PERegister.registerCPEditor('alert-closeText', 'alert-closeText-editor',
    PEFactory.createInputTextEditor('closeText', 'extension.setting.closeText'))

  PERegister.registerEPEditor('alert-center', 'alert-center-editor',
    PEFactory.createEventHandlerEditor('center', 'extension.setting.center'))

  PERegister.registerCPEditor('inputWidth', 'inputWidth-editor',
    PEFactory.createInputTextEditor('inputWidth', '文本框宽度1'))

  PERegister.registerCPEditor('unit', 'unit-editor',
  PEFactory.createInputTextEditor('unit', '单位'))

  let effectOptions = [
    { label: 'light', value: 'light' },
    { label: 'dark', value: 'dark' },
  ]
  PERegister.registerCPEditor('alert-effect', 'alert-effect-editor',
    PEFactory.createRadioButtonGroupEditor('effect', 'extension.setting.effect',
      { optionItems: effectOptions }))

  PERegister.registerEPEditor('alert-onClose', 'alert-onClose-editor',
    PEFactory.createEventHandlerEditor('onClose', []))
  /* -------------------------------------------------- */
  registerFWGenerator('alert', alertTemplateGenerator)  //注册字段组件的代码生成器
  /* -------------------------------------------------- */
  /* 字段组件加载完毕 end */
}
